import { useEffect, useState } from "react"
import { useDispatch, useSelector } from "react-redux"

import classes from './TransfersFilters.module.css'
import InputBox from "../common/interactive/InputBox"

import CustomSelect from "../common/interactive/CustomSelect"
import Button from "../common/Button"

import { practicesLocationsGroupedOptions, transfersStatusOptions } from "../../lib/systemData"
import { transfersActions } from "../../store/transfers"
import CustomSelectGroupedMultiple from "../common/interactive/CustomSelectGroupedMultiple"


export default function TransfersFilters() {
    const dispatch = useDispatch()
    const selectedFilters = useSelector(state => state.transfers.filters)
    const [rebuild, setRebuild] = useState(0)

    const [filtersValues, setFiltersValues] = useState(null)

    const TRANSFERS_DIRECTION_OPTIONS = [
        {
            label: 'To',
            value: 1
        },
        {
            label: 'From',
            value: 0
        }
    ]

    function mainSelectAction(value) {
        let update = {
            ...filtersValues,
        }

        //need to expand the object and include name of the selected options!
        if (value.data.value.constructor == Array) { // check if array
            update[value.identifier.type] = value.options
        } else {
            update[value.identifier.type]= {
                value: value.data.value,
                item: value.option
            }
        }   

        setFiltersValues(update)

        // on change set filters....
        dispatch(transfersActions.setCurrentPage(1))
        dispatch(transfersActions.setFiltersMultiple(update))
    }

    function clearAllFiltersHandler() {
        setRebuild(prev => prev+1)
        dispatch(transfersActions.setFiltersMultiple({}))   
    }

    // set the filters from settings 
    useEffect(() => {
        let mergeTheSelectedFilters = {
            ...selectedFilters
        }
        setFiltersValues(mergeTheSelectedFilters)        
    }, [selectedFilters])      


    return <div className={classes.master_filter}>

        <InputBox label={'Search'} action={mainSelectAction} name={'search'} currentValue={filtersValues?.search?.value} identifier={{type: 'search', label: 'Search'}} />
        <CustomSelectGroupedMultiple label={"Clinic"} optionsData={practicesLocationsGroupedOptions()} preSelectedValue={filtersValues?.location_ids?.value} action={mainSelectAction} name={'location_ids'} identifier={{type: 'location_ids', label: 'Status'}} rebuild={rebuild}/>

        <CustomSelect label={"Status"} optionsData={transfersStatusOptions()} preSelectedValue={filtersValues?.statuses?.value} action={mainSelectAction} name={'statuses'} identifier={{type: 'statuses', label: 'Status'}}/>

        <CustomSelect label={"Transfers"} optionsData={TRANSFERS_DIRECTION_OPTIONS} preSelectedValue={filtersValues?.transfer_in?.value} action={mainSelectAction} name={'transfer_in'} identifier={{type: 'transfer_in', label: 'Transfers'}}/>

        <Button click={clearAllFiltersHandler} btnStyle={'btn_white'}>Clear</Button>  

    </div>
}